import * as search from './types';

const mutations = {};

export default mutations;
